class BackendService {

  static instance;
  // domain = 'https://arminimum-skawa-eu.appspot.com';
  domain = 'https://ns-hu-premium-alerting-dot-arminimum-skawa-eu.appspot.com';
  endpoint = '_rm/ext/premium/alert/list';

  constructor () {
    if (!BackendService.instance) { BackendService.instance = this; }
    return BackendService.instance;
  }

  fetch = async (phoneNumber) => {
    const response = await fetch(`${this.domain}/${this.endpoint}/${phoneNumber}`);
    const body = await response.json();
    if (response.status !== 200) throw Error(body.message);
    return body;
  }

}

const instance = new BackendService();
Object.freeze(instance);

export default instance;



// WEBPACK FOOTER //
// ./src/services/BackendService/index.js